import { AutomationRunList } from "./AutomationRunList";
import { AutomationRunShow } from "./AutomationRunShow";

export default {
  list: AutomationRunList,
  show: AutomationRunShow,
  recordRepresentation: (record: {
    id: string | number;
    automation_key?: string;
  }) =>
    record?.automation_key
      ? `${record.automation_key} #${record.id}`
      : `Execução #${record?.id}`,
};
